import { render, staticRenderFns } from "./EditHousing.vue?vue&type=template&id=3d404bc8&scoped=true&"
import script from "./EditHousing.vue?vue&type=script&lang=js&"
export * from "./EditHousing.vue?vue&type=script&lang=js&"
import style0 from "./EditHousing.vue?vue&type=style&index=0&id=3d404bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d404bc8",
  null
  
)

export default component.exports